// extracted by mini-css-extract-plugin
export default {"title":"useColName_title__eR4G-","folder":"useColName_folder__npb+U"};